<template>
  <div :class="`input-radial-slider-${theme}`" class="input-radial-slider">
    <div class="radial-slider-number">
      <animating-number
        :current="innerValue"
        :em-offset-top="0"
        :include-zero="true"
        :left-easing="false"
        :show-total="false"
        :top-easing="!disableTransitions && !dragging"
        :total="total + 1"
        :width-easing="false"
        :width-left-multiplier="0.3"
        :duration="disableTransitions ? '0s' : '400ms'"
        text-align="center"
        transition-timing-function="cubic-bezier(0.34, 1.56, 0.64, 1)"
      />
      <div class="number-gradient" />
    </div>
    <div class="radial-slider-container">
      <vue3-slider
        v-model="innerValue"
        :height="6"
        :max="total + step"
        :min="0"
        :step="step"
        color="#45A4CD"
        orientation="circular"
        track-color="#C7D3DA"
        @drag-start="onDragStart"
        @drag-end="onDragEnd"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import slider from 'vue3-slider';

import AnimatingNumber from '@/components/AnimatingNumber/AnimatingNumber';
import InputComponent from '../InputComponent';

export default {
  name: 'InputRadialSlider',
  components: {
    AnimatingNumber,
    'vue3-slider': slider,
  },
  extends: InputComponent,
  props: {
    modelValue: {
      type: [Number, Array, String],
      required: false,
      default: 0,
    },
    total: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      required: false,
      default: 0.1,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: 0,
      dragging: false,
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['disableTransitions']),
    innerValueRounded() {
      return Math.round(this.innerValue);
    },
  },
  watch: {
    modelValue() {
      this.setInnerValueFromModelValue();
    },
    innerValue() {
      this.setModelValueFromInnerValue();
    },
  },
  mounted() {
    this.setInnerValueFromModelValue();
  },
  methods: {
    setInnerValueFromModelValue() {
      let newInnerValue = this.modelValue;

      if (newInnerValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newInnerValue = parseInt(newInnerValue[0], 10);
      } else if (typeof newInnerValue === 'string') {
        newInnerValue = parseInt(newInnerValue, 10);
      }

      if (newInnerValue === this.innerValueRounded) {
        return;
      }

      this.innerValue = newInnerValue;
    },
    setModelValueFromInnerValue() {
      let newValue = this.innerValueRounded;

      if (newValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newValue = newValue[0];
      }

      if (newValue === this.modelValue) {
        return;
      }

      this.$emit('update:modelValue', newValue);
    },
    onDragStart() {
      this.dragging = true;
    },
    onDragEnd() {
      this.dragging = false;

      // this.$nextTick(() => {
      this.innerValue = Math.round(this.innerValue);
      // });
    },
  },
};

</script>

<style lang="scss" scoped>
.input-radial-slider {
  position: relative;
  max-width: 400px;
  margin: 30px auto 0 auto;
}

.radial-slider-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<style lang="scss">
$circleSize: 30px;

.input-radial-slider {
  overflow: hidden;
  padding: 20px;

  .vue3-slider.circular .handle-container:last-child {
    //transition-duration: 150ms;
    //transition-timing-function: ease-out;

    .handle {
      top: $circleSize * -0.5;
      border-radius: math.div($circleSize, 2);
      width: $circleSize;
      height: $circleSize;
      transform: scale(1);

      transition-duration: 150ms;
      transition-timing-function: ease-in-out;

      &.hover {
        transform: scale(1.2);
      }
    }
  }

  .radial-slider-number {
    height: 80%;
  }

  .animating-number-container {
    height: 100%;
    position: relative;
    top: -10px;
  }

  .animating-number-current {
    height: 100% !important;
    width: 1.8em !important;
  }

  .animating-number-inner {
    color: #45A4CD !important;
  }

  $startPercent: 10%;
  $endPercent: 100% - $startPercent;

  $startPercentTransparency: 30%;
  $endPercentTransparency: 100 - $startPercentTransparency;

  .number-gradient {
    height: 110%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    //background: red;
    background: rgb(237, 241, 244);
    background: linear-gradient(180deg, rgba(237, 241, 244, 1) $startPercent, rgba(237, 241, 244, 0) $startPercentTransparency, rgba(237, 241, 244, 0) $endPercentTransparency, rgba(237, 241, 244, 1) $endPercent);
  }
}
</style>
